import { Accordion as BaseUiAccordion } from '@base-ui-components/react/accordion';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '#/ui/utils/types';

export interface AccordionItemProps extends React.PropsWithChildren<CommonProps<HTMLDivElement>> {}

function AccordionItem({ children, className, ...props }: AccordionItemProps) {
  return (
    <BaseUiAccordion.Item
      className={twMerge(
        'gooey-accordion-item overflow-hidden border-b border-gray-700 text-primary-contrast bg-background-default',
        className
      )}
      {...props}
    >
      {children}
    </BaseUiAccordion.Item>
  );
}
AccordionItem.display = 'GooeyAccordionItem';

export default AccordionItem;
